import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=14d4380d&scoped=true"
import script from "./ProductActions.vue?vue&type=script&lang=js"
export * from "./ProductActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d4380d",
  null
  
)

export default component.exports